import React from 'react';
import { Select, SelectProps, Typography } from 'antd';
import { noop } from 'lodash';
import { useQuery } from 'react-query';
import {
  getThirdPartyAddresListByTpid,
  GetThirdPartyAddresListByTpidParams,
  TpAddressResponse2,
} from 'services/thirdParty';

export type AddresseListSelectProps = SelectProps<any> & {
  value?: any;
  params: GetThirdPartyAddresListByTpidParams;
  onChange?: (Addresses: TpAddressResponse2) => void;
  onSelected?: (Addresses: TpAddressResponse2) => void;
  disabled?: boolean;
  allowClear?: boolean;
  display?: boolean;
  displayStyle?: React.CSSProperties;
};

const AddresseListSelect = ({
  value,
  params,
  onChange = noop,
  onSelected,
  display,
  displayStyle,
  ...otherProps
}: AddresseListSelectProps) => {
  const { data: Addresses, isLoading } = useQuery(
    ['getThirdPartyAddresListByTpid', params],
    () =>
      getThirdPartyAddresListByTpid(params).then((res) => {
        return res.list.filter((e) => e.adrstatus === 'VALID') || [];
      }),
    { enabled: params.tpid !== undefined }
  );

  const handleChange: SelectProps<any>['onChange'] = (value, option) => {
    onChange(value);
    if (onSelected) {
      onSelected(Addresses?.find((item) => item.tpadrid === value)!);
    }
  };
  return display ? (
    <Typography.Text style={displayStyle}>
      {Addresses?.find(
        (adr) =>
          adr.tpadrid ===
          (typeof value === 'object' ? value.tpadrid : Number(value))
      )?.tpmainadrcitylabel +
        ' - ' +
        Addresses?.find(
          (adr) =>
            adr.tpadrid ===
            (typeof value === 'object' ? value.tpadrid : Number(value))
        )?.tpmainadrstreet1}
    </Typography.Text>
  ) : (
    <Select
      onChange={handleChange}
      {...otherProps}
      loading={isLoading}
      allowClear
      value={!value?.tpadrid ? value : value.tpadrid}
    >
      {Addresses?.map((adr) => (
        <Select.Option value={adr.tpadrid} key={adr.tpadrid}>
          {adr.tpmainadrcitylabel + ' - ' + adr.tpmainadrstreet1}
        </Select.Option>
      ))}
    </Select>
  );
};

export default AddresseListSelect;
